import { Transform, plainToInstance } from "class-transformer";
import { FormAnswer } from "./form-answer.model";
import { FormTemplateQuestion, QuestionTypeEnum } from "./form-template-question.model";
import { QuestionList } from "./question-list.model";
import { QuestionRange } from "./question-range.model";
import { QuestionText } from "./question-text.model";

export class MergeResult {
  sourceFormGroupInstanceId: number;
  sourceFormInstanceId: number;
  destinationFormGroupInstanceId: number;
  destinationFormInstanceId: number;
  countUnmappedQuestions: number;
  mergeResponsesIds: number[];
  @Transform(({ value }: { value: { question: FormTemplateQuestion; answer: FormAnswer }[] }) => {
    const transformedAnswers: { question: FormTemplateQuestion | null; answer: FormAnswer }[] = [];
    for (let i = 0; i < value.length; i++) {
      let formTemplateQuestion: FormTemplateQuestion | null = null;
      switch (value[i].question.type) {
        case QuestionTypeEnum.Range:
          formTemplateQuestion = plainToInstance(QuestionRange, value[i].question);
          break;
        case QuestionTypeEnum.List:
          formTemplateQuestion = plainToInstance(QuestionList, value[i].question);
          break;
        case QuestionTypeEnum.Text:
          formTemplateQuestion = plainToInstance(QuestionText, value[i].question);
          break;
        default:
          break;
      }
      transformedAnswers.push({ question: formTemplateQuestion, answer: value[i].answer });
    }
    return transformedAnswers;
  })
  unmappedAnswers: { question: FormTemplateQuestion; answer: FormAnswer }[];
  formInstanceMergeHistoryId: number;
  existingResponsesIds: number[];
}

export type IMergeItem = {
  sourceFormInstanceId: number;
  destinationFormInstanceId: number;
};

export type IMergeResponsesInput = {
  mergeItems: IMergeItem[];
};

export type IUdnoMergeItem = {
  formInstanceMergeHistoryId:number;
}

export type IUndoMergeResponsesInput = {
  mergeItems: IUdnoMergeItem[];
};
